<template>
	<app-page>
		<app-heading :title="isNew ? 'New Participant'
			: `${participant.first_name} ${participant.last_name}`" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'market-participants' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="First Name"
					v-model="participant.first_name"
					required
					:errors="errors.first_name"
				/>
				<input-text
					label="Last Name"
					v-model="participant.last_name"
					required
					:errors="errors.last_name"
				/>
				<input-text
					type="email"
					label="Email"
					v-model="participant.email"
					:errors="errors.email"
				/>
				<input-text
					type="phone"
					label="Phone"
					v-model="participant.phone"
					:errors="errors.phone"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.participant = await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('participants')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			participant: {
				first_name: '',
				last_name: '',
				email: '',
				phone: '',
			},
			errors: {},
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		id() {
			return this.$route.params.participant
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			const request = this.$ravello.request()
				.v(2)
				.to('markets')
				.to(this.marketId)
				.to('participants')

			const payload = {
				first_name: this.participant.first_name,
				last_name: this.participant.last_name,
				email: this.participant.email,
				phone: this.participant.phone,
			}

			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request
						.to(this.id)
						.update(payload)
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Participant successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'market-participants' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
